/**
 * If you need to add more, reference the media queries in {@link app/view/static/css/_media-queries.less}.
 */
const mediaQueries = {
  phones: '(max-width: 479px)',
  phonesAndTabletSmall: '(max-width: 767px)',
  phonesAndTablet: '(max-width: 991px)',
  tabletAndDesktop: '(min-width: 768px)',
  desktopAll: '(min-width: 992px)',
};

/**
 * Check media queries in JS. Useful when you need to write javascript that needs to do
 * different things based on CSS queries.
 */
const isMedia = (type: keyof typeof mediaQueries = 'phonesAndTabletSmall'): boolean => (
  window.matchMedia(mediaQueries[type]).matches
);

export default isMedia;
